import React from "react";
import { I18n } from "../i18n";
import type { RenderSiteProps } from "./RenderSite";

export const Faq: React.FC<RenderSiteProps> = ({ site }) => {
  const faq = site.faq;
  const items = faq?.items?.filter(
    (item) => item.question?.trim() && item.answer?.trim()
  );
  if (!faq?.is_enabled || !items?.length) {
    return null;
  }

  const i18n = I18n(site.language);

  return (
    <section id="faq" className="py-16 bg-gray-100">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-gray-800 text-center mb-4 first-letter:uppercase">
          {faq.title || i18n["Frequently asked questions"]}
        </h2>
        {faq.description && (
          <p className="text-gray-700 text-center mb-10 first-letter:uppercase">
            {faq.description}
          </p>
        )}
        <div className="space-y-4">
          {items.map((item, index) => (
            <details
              className="group rounded-lg border border-gray-200 bg-white shadow-sm"
              key={item.id || `faq-${index}`}
            >
              <summary className="cursor-pointer list-none px-6 py-5 text-lg font-semibold text-gray-800 marker:hidden">
                <span className="flex items-center justify-between gap-4">
                  {item.question}
                  <span aria-hidden="true" className="text-2xl font-normal group-open:rotate-45">
                    +
                  </span>
                </span>
              </summary>
              <div className="px-6 pb-5 text-gray-700">
                {item.answer.split("\n").map((line, lineIndex) => (
                  <p key={`${item.id || index}-${lineIndex}`}>{line}</p>
                ))}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
